
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DimensionValueModel extends Model<DimensionValueModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'code', type: 'string' },
		{ name: 'dimensionCode', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'blocked', type: 'boolean' }
	];
	[key: string]: any;
	
	public code: string;
	public dimensionCode: string;
	public name: string;
	public blocked?: boolean;
    
	constructor(){
		super();
		this.code = '';
		this.dimensionCode = '';
		this.name = '';
		this.blocked = undefined;
		
	}
	getProperties(){
		return DimensionValueModel.classProperties;
	}
}

